import axios from "axios";
import {
  birthDaysRequested,
  birthDaysRequestSucceeded,
  birthDaysRequestFailed,
} from "../slices/GetBirthDaysByCountrySlice";
//const selectedCountry = localStorage.getItem("selectedCountry");

/* const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Category/GetActivesByCountry?countryName=${encodeURIComponent(
  selectedCountry
)}`; */
const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Home/GetBirthDays`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const getBirthDays = () => async (dispatch) => {
  try {
    dispatch(birthDaysRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(birthDaysRequestSucceeded(response.data));
  } catch (error) {
    dispatch(birthDaysRequestFailed(error.message));
  }
};
